import React, { useState } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';

export default function LabeledDashedInput(props) {
  const { label, defaultVal, setVal, type, multiline, maxLength, maxLengthAlert, numericOnly } = props;

  const { t } = useLanguage();

  const [value, setValue] = useState(defaultVal);

  function onChangeInput(e) {
    const nextValue = numericOnly ? e.target.value.replace(/[^0-9]/g, '') : e.target.value;

    if (maxLength !== undefined && nextValue.length > maxLength) {
      if (maxLengthAlert) setTimeout(() => alert(t(maxLengthAlert)), 0);
      return;
    }

    setValue(nextValue);
    setVal(nextValue);
  }

  return (
    <TopLevelWrapper>
      <Label>{label}</Label>
      {
        multiline ?
          <DashedTextArea
            value={value}
            onChange={onChangeInput} />
          :
          <DashedInput
            type={type}
            value={value}
            onChange={onChangeInput} />
      }
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 5px;

  width: 100%;
`;

const Label = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const DashedInput = styled.input`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  width: 100%;
  height: 30px;

  padding: 5px 10px;
  box-sizing: border-box;

  outline: none;
  border: 1px dashed ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.gray};
  }
`;

const DashedTextArea = styled.textarea`
  font-family: NotoSansKR-Medium;
  font-size: 14px;
  line-height: 1.4;

  width: 100%;
  min-height: 50px;

  padding: 5px 10px;
  box-sizing: border-box;
  resize: none;

  outline: none;
  border: 1px dashed ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.subBackground};
  color: ${props => props.theme.text};

  ::placeholder {
    color: ${props => props.theme.gray};
  }

  &::-webkit-scrollbar {
    width: 9px;
  }

  &::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
    border: 3px solid transparent;
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;
